import { publicOperationMiddleware } from '../permissions/middlewares/publicOperationMiddleware.js';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { SGCONFIG_ID, SGConfig } from '@martinus/global-config/db/sg-config.js';
import { html } from 'lit';

export const isSusEntryFormActive = registerQuery({
  operationName: 'isSusEntryFormActive',
  middlewares: [publicOperationMiddleware('Oeffentliches SuS-Anmeldeformular')],
  type: () => Boolean,
  resolve: () => async () => {
    const configCol = await getRawCollection<SGConfig>(SGConfig._collectionName);
    const config = await configCol.findOne({ _id: SGCONFIG_ID }, { projection: { activatedSUSForm: 1 } });
    return !!config?.activatedSUSForm;
  },
});

export const inActiveUI = html`<section class="card w-full">
  <div class="card-body gap-3">
    <span class="icon-[material-symbols--schedule-rounded] text-3xl text-primary" aria-hidden="true"></span>
    <h2 class="font-semibold md:text-lg">Das Anmeldeformular ist derzeit nicht aktiv</h2>
    <p>Die Online-Anmeldung ist aktuell deaktiviert. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.</p>
  </div>
</section>`;
